<template>
  <product-detail
    v-if="product"
    :key="$route.path"
    v-bind="product"
    :product="product"
    :shopify-product="shopifyProduct"
    :is-canned="isCanned"
    use-flavor-selector
    :path="path"
    :featured-press="featuredPress"
    :show-press="showPress"
    :show-testimonials="showTestimonials"
    class="product--sparkling-water"
  >
    <template v-if="ingredientsDoc && product.ingredients" #after-header>
      <page-section
        v-if="product.ingredients.length > 0"
        :title="ingredientOverrides.title || ingredientsDoc.title"
        :subtitle="ingredientOverrides.subTitle || ingredientsDoc.description"
      >
        <ingredients :ingredients="product.ingredients" class="text-center" />
      </page-section>
    </template>
  </product-detail>
</template>

<script>
import { mapState } from 'vuex'
import page from '~/mixins/page'
import productDetail from '~/mixins/product-detail'
import ProductDetail from '~/components/shop/products/product-detail.vue'
import Ingredients from '~/components/shop/ingredients/ingredients.vue'

export default {
  components: {
    ProductDetail,
    Ingredients
  },

  mixins: [page, productDetail],

  data: () => ({
    product: null,
    shopifyProduct: null,
    path: null
  }),

  computed: {
    ...mapState('shop', {
      ingredientsDoc: state => state.ingredients
    }),
    isCanned() {
      return ['recess-mood', 'sparkling-water'].includes(this.product.category)
    }
  }
}
</script>

<style>
.product--sparkling-water .cart-input--radios {
  flex: 0 1 auto;
  max-width: 50%;
  min-width: 0;
  text-align: center;
}

.product--sparkling-water .radio-group.input label {
  padding-left: 0;
}

.product__nutrition-facts ul {
  display: block;
  font-size: theme('fontSize.base');
}
</style>
